import dayjs from 'dayjs';
import 'dayjs/locale/de';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import minMaxDayjs from 'dayjs/plugin/minMax';
import localeData from 'dayjs/plugin/localeData';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';

export function initDayJs() {
  dayjs.locale('de');
  dayjs.extend(utc);
  dayjs.extend(localeData);
  dayjs.extend(localizedFormat);
  dayjs.extend(customParseFormat);
  dayjs.extend(minMaxDayjs);
}
